/* eslint-disable */
export default {
  downloadSuccess: '記錄已下載。',
  downloadFail: '錯誤記錄下載失敗。請再試一次。',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
